import { useMe } from "./useMe";

export type Persona = "owner" | "operator" | "staff" | "approver" | "reviewer" | "cxo";

const ALLOWED: ReadonlySet<string> = new Set([
  "owner",
  "operator",
  "staff",
  "approver",
  "reviewer",
  "cxo",
]);

/**
 * Resolves the current user's persona inside a given workspace.
 *
 * Returns `null` while loading, and falls back to `"operator"` if the user has
 * no membership for the supplied workspaceId (defensive — a `requireWorkspace`
 * check upstream should normally prevent this).
 */
export function usePersona(workspaceId: string | null | undefined): Persona | null {
  const { data: me, isLoading } = useMe();
  if (isLoading) return null;
  if (!me || !workspaceId) return null;
  const m = me.memberships.find((mem) => mem.workspaceId === workspaceId);
  if (!m) return "operator";
  return ALLOWED.has(m.role) ? (m.role as Persona) : "operator";
}
